import React from 'react';
import './VideoBackground.css';

export const VideoBackground = ({ video }) => {
  return <div className="video-wrapper">
    <div className="video-background">
      <video id="video1" autoPlay muted playsInline loop>
        <source src={video} type="video/mp4" />
        Your browser does not support HTML video.
      </video>
    </div>
  </div>;
};
